module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ca-2ef1694a264cbd2ab8595034c676da87.svg";